import { render, staticRenderFns } from "./DeliveryPDF.vue?vue&type=template&id=cbcebb24"
import script from "./DeliveryPDF.vue?vue&type=script&lang=js"
export * from "./DeliveryPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports